module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    attrs: {
      "id": "nhMainPhone"
    }
  }, [_c('div', {
    staticClass: "topButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n        ")])], 1), _vm._v(" "), _c('el-main', {
    staticClass: "phoneMainBox",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('el-tabs', {
    attrs: {
      "tab-position": _vm.tabPosition
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [(_vm.flag.info) ? _c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 实习信息")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 实习信息")])]), _vm._v(" "), (_vm.flag.one) ? _c('div', {
    style: ({
      'height': _vm.mainHeight + 'px'
    })
  }, [_c('infoMobile', {
    attrs: {
      "div-height": _vm.mainHeight
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.flag.summary) ? _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-notebook-1"
  }), _vm._v(" 实习周记")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-notebook-1"
  }), _vm._v(" 实习周记")])]), _vm._v(" "), (_vm.flag.two) ? _c('div', {
    style: ({
      'height': _vm.mainHeight + 'px'
    })
  }, [_c('summaryMobile', {
    attrs: {
      "div-height": _vm.mainHeight
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.flag.guidance) ? _c('el-tab-pane', {
    attrs: {
      "name": "third"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" 现场指导")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" 现场指导")])]), _vm._v(" "), (_vm.flag.thr) ? _c('div', {
    style: ({
      'height': _vm.mainHeight + 'px'
    })
  }, [_c('reportMobile', {
    attrs: {
      "div-height": _vm.mainHeight
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.flag.apply) ? _c('el-tab-pane', {
    attrs: {
      "name": "four"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-phone-outline"
  }), _vm._v(" 自主联系")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-phone-outline"
  }), _vm._v(" 自主联系申请")])]), _vm._v(" "), (_vm.flag.fou) ? _c('div', {
    style: ({
      'height': _vm.mainHeight + 'px'
    })
  }, [_c('autonomouslyApplyMobile', {
    attrs: {
      "div-height": _vm.mainHeight
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.flag.change) ? _c('el-tab-pane', {
    attrs: {
      "name": "five"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 实习变更")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 实习变更申请")])]), _vm._v(" "), (_vm.flag.fiv) ? _c('div', {
    style: ({
      'height': _vm.mainHeight + 'px'
    })
  }, [_c('practiceChangeMobile', {
    attrs: {
      "div-height": _vm.mainHeight
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e626b992"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/practiceManageMobile.vue
// module id = 1909
// module chunks = 502